// import event Bus
import maEventbus from '@/components/eventbus'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

const DAMAGE_BILLMA_AGENT_NEW = 'damage_billma_agent_new'
const E2E_NEW = 'e2e_new'

/**
 * @module
 * @name Accordion
 */
export default {
  name: 'Accordion',
  mixins: [userFlowMixin],
  /**
   * @property {Boolean} expanded If accordion is initially expanded.
   */
  props: {
    expanded: {
      type: Boolean,
      required: false
    },
    confirmed: {
      type: Boolean,
      required: false
    }
  },
  /**
   * @property {Boolean} collapsed Management of accordion collapse, inited with
   *                               the opposite of property expanded.
   *
   */
  data: function () {
    return {
      collapsed: !this.expanded,
      deletedBtn: false,
      showDeleteBtn: false,
      pieceConfirmed: this.confirmed
    }
  },
  /**
   * @property {String} accordionClasses
   * @property {Object} accordion
   * @property {Float} bottomHeight
   */
  computed: {
    isPhotoclaimFlow() {
      return this.isPhotoclaimUser
    },
    flowName() {
      return this.getUserFlow
    },
    isMultidamageFlow() {
      return this.flowName === DAMAGE_BILLMA_AGENT_NEW || this.isPhotoclaimFlow
    },
    accordionClasses() {
      let accordionExpanded = !this.collapsed ? 'accordion--expanded' : ''
      return accordionExpanded
    },
    accordion() {
      let sectionToClose = this.$el.querySelector('.accordion__bottom')
      let sectionToCloseHeight = sectionToClose.scrollHeight
      let sectionToCloseTransition = sectionToClose.style.transition

      sectionToClose.style.transition = ''

      return {
        sectionToClose,
        sectionToCloseHeight,
        sectionToCloseTransition
      }
    },
    bottomHeight: function () {
      return this.accordion.sectionToClose.style.height
    }
  },
  methods: {
    /**
     * @function
     * @name toggleAccordion
     * @description Toggle accordion
     */
    toggleAccordion: function () {
      if (this.collapsed === false) {
        this.hideContent()
      } else {
        this.showContent()
      }
    },
    /**
     * @function
     * @name hideContent
     * @description Collapse accordion, animation include
     */
    hideContent: function () {
      const that = this
      this.collapsed = true

      that.accordion.sectionToClose.style.transition =
        that.accordion.sectionToCloseTransition

      requestAnimationFrame(function () {
        that.accordion.sectionToClose.style.height =
          that.accordion.sectionToCloseHeight + 'px'

        requestAnimationFrame(function () {
          that.accordion.sectionToClose.style.height = 0 + 'px'
        })
      })
    },
    /**
     * @function
     * @name showContent
     * @description Expand accordion. It's used on accordion click i.e.
     */
    showContent() {
      const that = this
      this.collapsed = false
      that.accordion.sectionToClose.style.transition =
        that.accordion.sectionToCloseTransition

      requestAnimationFrame(function () {
        that.accordion.sectionToClose.style.height = 'auto'
      })
    },

    confirmPiece() {
      this.hideContent()
      this.pieceConfirmed = true
    },
    /**
     * @function
     * @name resizeContent
     * @description Resize height of accordion. It's used when item numbers are
     *              modified.
     */
    resizeContent: function () {
      setTimeout(() => {
        let el = this.$el.querySelector('.accordion__bottom > div')
        this.accordion.sectionToCloseHeight =
          el && 'offsetHeight' in el ? el.offsetHeight : 0
        this.showContent()
      }, 500)
    },
    handleMoreOptions() {
      if (this.collapsed) return
      this.showDeleteBtn = !this.showDeleteBtn
    }
  },
  /**
   * @function
   * @name mounted
   * @description If accordion is initially expanded, the height is calculated.
   *              It's also set eventBus handler for @accordion:resize event
   */
  mounted() {
    if (this.expanded === true) {
      this.accordion.sectionToClose.style.height =
        this.accordion.sectionToCloseHeight + 'px'
    }
    maEventbus.$on(
      'accordion:resize',
      /**
       * Accordion resize event.
       *
       * @event
       * @name accordion:resize
       * @description On resize, height is calculated and the content is showed.
       */
      () => {
        setTimeout(() => {
          let el = this.$el.querySelector('.accordion__bottom > div')
          this.accordion.sectionToCloseHeight =
            el && 'offsetHeight' in el ? el.offsetHeight : 0
          !this.collapsed && this.showContent()
        })
      }
    )
  }
}
